export const specialList = ['~', '!', '@', '#', '$', '%', '^', '&', '*', '(', ')', '_', '=', '-', '/', ',', '.', '?', '<', '>', ';', ':', '[', ']', '{', '}', '|', '\\'];
export const numberList = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0'];
export const wordList = [
    'q',
    'a',
    'z',
    'w',
    's',
    'x',
    'e',
    'd',
    'c',
    'r',
    'f',
    'v',
    't',
    'g',
    'b',
    'y',
    'h',
    'n',
    'u',
    'j',
    'm',
    'i',
    'k',
    'o',
    'l',
    'p',
    'Q',
    'A',
    'Z',
    'W',
    'S',
    'X',
    'E',
    'D',
    'C',
    'R',
    'F',
    'V',
    'T',
    'G',
    'B',
    'Y',
    'H',
    'N',
    'U',
    'J',
    'M',
    'I',
    'K',
    'O',
    'L',
    'P',
];
